import { gql } from '@apollo/client'

export const MARK_ALL_NOTIFICATIONS_READ_MUTATION = gql`
  mutation markAllNotificationsRead {
    markAllNotificationsRead {
      success
      errors
    }
  }
`
